import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
export function ProblemSection() {
  return <SectionWrapper alternate data-id="element-223">
      <motion.h2 className="font-heading text-2xl md:text-3xl font-bold text-cream mb-10" variants={childVariants} data-id="element-224">
        The problem nobody warns you about
      </motion.h2>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-8" variants={childVariants} data-id="element-225">
        Most sleep advice is built for people who can't <em data-id="element-226">fall</em> asleep.
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-8" variants={childVariants} data-id="element-227">
        But if you're a woman 45+, the real sabotage often looks like this:
      </motion.p>

      <motion.ul className="space-y-4 mb-10" variants={childVariants} data-id="element-228">
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-229">
          <span className="mt-2 w-2 h-2 rounded-full bg-teal flex-shrink-0" data-id="element-230" />
          You fall asleep fine
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-231">
          <span className="mt-2 w-2 h-2 rounded-full bg-teal flex-shrink-0" data-id="element-232" />
          You wake up between 2–4am
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-233">
          <span className="mt-2 w-2 h-2 rounded-full bg-teal flex-shrink-0" data-id="element-234" />
          Your body feels hot, jittery, or alert
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-235">
          <span className="mt-2 w-2 h-2 rounded-full bg-teal flex-shrink-0" data-id="element-236" />
          Your brain starts sprinting
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-237">
          <span className="mt-2 w-2 h-2 rounded-full bg-teal flex-shrink-0" data-id="element-238" />
          You try to "figure it out"
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-amber font-medium leading-relaxed-plus" data-id="element-239">
          <span className="mt-2 w-2 h-2 rounded-full bg-amber flex-shrink-0" data-id="element-240" />
          And suddenly you're not just awake… you're up
        </li>
      </motion.ul>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-6" variants={childVariants} data-id="element-241">
        Then you pay for it all day:
      </motion.p>

      <motion.p className="font-body text-lg text-cream-muted leading-loose-plus mb-10 pl-4 border-l-2 border-amber/30" variants={childVariants} data-id="element-242">
        foggy, thin-skinned, cravings, headaches, anxiety spikes, no patience,
        zero capacity.
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-4" variants={childVariants} data-id="element-243">
        And the worst part?
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-4" variants={childVariants} data-id="element-244">
        At night you start <em className="text-amber" data-id="element-245">bracing</em> for it.
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-4" variants={childVariants} data-id="element-246">
        You go to bed already afraid of 3am.
      </motion.p>

      <motion.p className="font-heading text-xl text-cream-muted italic leading-relaxed-plus" variants={childVariants} data-id="element-247">
        That fear becomes the invitation.
      </motion.p>
    </SectionWrapper>;
}